module.exports = __webpack_public_path__ + "static/media/shape0.pngfeat0.27bda7c0.png";